export default "__VITE_ASSET__Cb0_0ck$__"